module.exports = __webpack_public_path__ + "static/media/11-contact.820c1cde.png";